(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gv-reservation"] && !Shopify.designMode) return;
  try {
    (() => {
    const loadTurnstile = () => {
      if (window.turnstile) return Promise.resolve(window.turnstile);
      if (!window.gvReservationTurnstilePromise) {
        window.gvReservationTurnstilePromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true;
          script.onload = () => window.turnstile ? resolve(window.turnstile) : reject(new Error('Turnstile'));
          script.onerror = () => reject(new Error('Turnstile'));
          document.head.appendChild(script);
        });
      }
      return window.gvReservationTurnstilePromise;
    };

    const init = async (root) => {
      if (root.dataset.initialized === '1') return;
      root.dataset.initialized = '1';
      const details = root.querySelector('details');
      const form = root.querySelector('form');
      const status = root.querySelector('.gv-reservation__status');
      const submit = root.querySelector('.gv-reservation__submit');
      const turnstileContainer = root.querySelector('.gv-reservation__turnstile');
      const endpoint = root.dataset.api;
      let siteKey = '';
      let token = '';
      let widgetId = null;
      let submitting = false;

      const message = (text) => { status.textContent = text || ''; };
      const resetChallenge = () => {
        token = '';
        if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId);
      };
      const showChallenge = async () => {
        if (!siteKey || widgetId !== null) return;
        message(root.dataset.challenge);
        try {
          const turnstile = await loadTurnstile();
          widgetId = turnstile.render(turnstileContainer, {
            sitekey: siteKey,
            action: 'reserve',
            appearance: 'interaction-only',
            callback: (value) => { token = value; message(''); },
            'expired-callback': () => { token = ''; message(root.dataset.challenge); },
            'error-callback': () => { token = ''; message(root.dataset.error); },
          });
        } catch {
          message(root.dataset.error);
        }
      };

      details.addEventListener('toggle', () => { if (details.open) showChallenge(); });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (submitting || !siteKey || !form.reportValidity()) return;
        if (!token) { message(root.dataset.challenge); return; }
        submitting = true;
        submit.disabled = true;
        message(root.dataset.loading);
        try {
          const result = await fetch(`${endpoint}/reserve`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              variantId: root.dataset.variant,
              name: form.elements.namedItem('name').value,
              email: form.elements.namedItem('email').value,
              turnstileToken: token,
            }),
          });
          const data = await result.json();
          if (!result.ok || !data.ok) throw new Error(data.error || root.dataset.error);
          root.dataset.reserved = '1';
          message(root.dataset.success);
          const buyForm = root.parentElement?.querySelector('product-form button[type="submit"]');
          if (buyForm) buyForm.disabled = true;
        } catch (error) {
          message(error.message || root.dataset.error);
          submitting = false;
          submit.disabled = false;
          resetChallenge();
        }
      });

      try {
        const response = await fetch(`${endpoint}/config`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Config');
        const config = await response.json();
        if (!config.enabled || !config.siteKey) {
          message('');
          return;
        }
        siteKey = config.siteKey;
        submit.disabled = false;
        try {
          const availabilityResponse = await fetch(`${endpoint}/availability?variantId=${encodeURIComponent(root.dataset.variant)}`);
          if (availabilityResponse.ok) {
            const availability = await availabilityResponse.json();
            if (availability.reserved) {
              submit.disabled = true;
              message(root.dataset.unavailable);
              return;
            }
          }
        } catch {}
        if (details.open) showChallenge();
      } catch {
        message('');
      }
    };

    document.querySelectorAll('[data-gv-reservation]').forEach(init);
  })();
  } catch(e) { console.error(e); }
})();

})();
